import axios from "axios";
import configuration from "@/utils/configuration";
import { handleError } from "@/utils/errorHandler";

export default {
  namespaced: true,

  state: {
    user: JSON.parse(localStorage.getItem("user")) || null,
    loading: {},
    error: {},
    usersByRole: null,
  },
  getters: {
    isLoading: (state) => (action) => !!state.loading[action],
    getError: (state) => (action) => state.error[action],
    getUsersByRole: (state) => state.usersByRole, 
  },
  mutations: {
    SET_LOADING(state, { action, status }) {
      state.loading = { ...state.loading, [action]: status };
    },
    SET_ERROR(state, { action, message }) {
      state.error = { ...state.error, [action]: message };
    },
    SET_USERS_BY_ROLE(state, usersByRole) {
      state.usersByRole = usersByRole;
    },
  },
  actions: {

    //GET ALL USER
    async getAllUser({ commit }) {
      const action = "getAllUser";
      commit("SET_LOADING", { action, status: true });
      try {
        const response = await axios({
          method: "GET",
          url: `${configuration.backUrl}/users?page=1&limit=100`,
          withCredentials: true,
        });
        return response.data;
      } catch (error) {
        handleError(commit, action, error);
        throw error;
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },
    //GET USER BY ROLE
    async getUsersByRole({ commit }, { roleCode, page = 1, limit = 100 }) {
      const action = "getUsersByRole";
      commit("SET_LOADING", { action, status: true });
      try {
        const { data } = await axios.get(
          `${configuration.backUrl}/users/by-role`,
          {
            params: {
              role_code: roleCode,
              page: page,
              limit: limit,
            },
          }
        );
        commit("SET_USERS_BY_ROLE", data.data);
      } catch (error) {
        handleError(commit, action, error);
        throw error;
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },
    async getUsersRoleCoach({ commit }) {
      const action = "getUsersRoleCoach";
      commit("SET_LOADING", { action, status: true });
      try {
        const { data } = await axios({
          method: "GET",
          url: `${configuration.backUrl}/users/coach`,
          withCredentials: true,
        });
        commit("SET_USERS_BY_ROLE", data.data);
        return data.data;
      } catch (error) {
        handleError(commit, action, error);
        throw error;
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },
    //  FOR ADMIN PAGE

    async getAllUserlist({ commit }, params) {
      const action = "getAllUserlist";
      commit("SET_LOADING", { action, status: true });
      try {
        const { data } = await axios({
          method: "GET",
          url: `${configuration.backUrl}/users/management`,
          withCredentials: true,
          params: params,
        });
        return data.data;
      } catch (error) {
        handleError(commit, action, error);
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },
    async getSearchUser({ commit }, { keyword, role, page, limit }) {
      const action = "getSearchUser";
      commit("SET_LOADING", { action, status: true });
      try {
        const { data } = await axios({
          method: "GET",
          url: `${configuration.backUrl}/users/management/role/search`,
          withCredentials: true,
          params: {
            keyword: keyword,
            role: role,
            page: page,
            limit: limit,
          },
        });
        return data.data;
      } catch (error) {
        handleError(commit, action, error);
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },

    async getUserDetail({ commit }, userId) {
      const action = "getUserDetail";
      commit("SET_LOADING", { action, status: true });
      try {
        const { data } = await axios.get(
          `${configuration.backUrl}/users/management/view`,
          {
            withCredentials: true,
            params: { user_id: userId },
          }
        );
        return data.data;
      } catch (error) {
        handleError(commit, action, error);
        throw error;
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },
    async deleteUser({ commit }, userId) {
      const action = "deleteUser";
      commit("SET_LOADING", { action, status: true });
      try {
        const { data } = await axios({
          method: "DELETE",
          url: `${configuration.backUrl}/users/management`,
          withCredentials: true,
          params: { user_id: userId },
        });
        return data.data;
      } catch (error) {
        handleError(commit, action, error);
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },
    async getUserDetailForAdmin({ commit }, userId) {
      const action = "getUserDetailForAdmin";
      commit("SET_LOADING", { action, status: true });
      try {
        const { data } = await axios.get(
          `${configuration.backUrl}/users/management/view`,
          {
            withCredentials: true,
            params: { user_id: userId },
          }
        );
        return data.data;
      } catch (error) {
        handleError(commit, action, error);
        throw error;
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },
    async getUserRelationShip({ commit }, userId) {
      const action = "getUserRelationShip";
      commit("SET_LOADING", { action, status: true });
      try {
        const { data } = await axios.get(
          `${configuration.backUrl}/users/management/relationships`,
          {
            withCredentials: true,
            params: { user_id: userId },
          }
        );
        return data.data;
      } catch (error) {
        handleError(commit, action, error);
        throw error;
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },
    async editUserRole({ commit }, params) {
      const action = "editUserRole";
      commit("SET_LOADING", { action, status: true });
      try {
        const { data } = await axios({
          method: "PATCH",
          url: `${configuration.backUrl}/users/management/role`,
          withCredentials: true,
          params: params,
        });
        return data.data;
      } catch (error) {
        handleError(commit, action, error);
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },
    async postNewUser({ commit }, userDetail) {
      const action = "postNewUser";
      commit("SET_LOADING", { action, status: true });
      try {
        const { data } = await axios({
          method: "POST",
          url: `${configuration.backUrl}/users`,
          withCredentials: true,
          data: userDetail,
        });
        return data;
      } catch (error) {
        commit("SET_ERROR", {
          action,
          message:
            error.response?.data?.message ||
            error.message ||
            `${action} Failed`,
        });
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },
    // ----------  ADMIN STUDENT IN COURSE LIST -----------------

    async getOngoingStudentList({ commit }, params) {
      const action = "getOngoingStudentList";
      commit("SET_LOADING", { action, status: true });
      try {
        const { data } = await axios.get(
          `${configuration.backUrl}/course/management/student-study`,
          {
            withCredentials: true,
            params:params,
          }
        );
        return data.data;
      } catch (error) {
        handleError(commit, action, error);
        throw error;
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },
    async getOngoingStudentSort({ commit }, params) {
      const action = "getOngoingStudentSort";
      commit("SET_LOADING", { action, status: true });
      try {
        const { data } = await axios.get(
          `${configuration.backUrl}/course/management/student-class`,
          {
            withCredentials: true,
            params:params,
          }
        );
        return data.data;
      } catch (error) {
        handleError(commit, action, error);
        throw error;
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },
    async getReserveStudentOnCourse({ commit }, params) {
      const action = "getReserveStudentOnCourse";
      commit("SET_LOADING", { action, status: true });
      try {
        const { data } = await axios({
          method: "GET",
          url: `${configuration.backUrl}/course/management/student-reserve`,
          params: params,
          withCredentials: true,
        });
        return data.data;
      } catch (error) {
        handleError(commit, action, error);
        throw error;
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },
    async getCompleteStudentOnCourse({ commit }, params) {
      const action = "getCompleteStudentOnCourse";
      commit("SET_LOADING", { action, status: true });
      try {
        const { data } = await axios({
          method: "GET",
          url: `${configuration.backUrl}/course/management/student-complete`,
          params:params,
          withCredentials: true,
        });
        return data.data;
      } catch (error) {
        handleError(commit, action, error);
        throw error;
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },
    async getUserCourseAdminView({ commit }, userId) {
      const action = "getUserCourseAdminView";
      commit("SET_LOADING", { action, status: true });
      try {
        const { data } = await axios({
          method: "GET",
          url: `${configuration.backUrl}/users/management/courses`,
          params: { user_id: userId },
          withCredentials: true,
        });
        return data.data;
      } catch (error) {
        handleError(commit, action, error);
        throw error;
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },
    async getStudentListAdminView({ commit }, params) {
      const action = "getStudentListAdminView";
      commit("SET_LOADING", { action, status: true });
      try {
        const { data } = await axios({
          method: "GET",
          url: `${configuration.backUrl}/users/management/search`,
          params:params,
          withCredentials: true,
        });
        return data.data;
      } catch (error) {
        handleError(commit, action, error);
        throw error;
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },
     async createUserNoOneID({ commit }, payload) {
      const action = "createUserNoOneID";
      commit("SET_LOADING", { action, status: true });
      try {
        const { data } = await axios({
          method: "POST",
          url: `${configuration.backUrl}/users`,
          data:payload,
          withCredentials: true,
        });
        return data.data;
      } catch (error) {
        handleError(commit, action, error);
        throw error;
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },
  },
};

